import { render } from "./AppMessageInput.vue?vue&type=template&id=c485886c&scoped=true&ts=true"
import script from "./AppMessageInput.vue?vue&type=script&lang=ts"
export * from "./AppMessageInput.vue?vue&type=script&lang=ts"

import "./AppMessageInput.vue?vue&type=style&index=0&id=c485886c&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c485886c"]])

export default __exports__